module.exports = __webpack_public_path__ + "static/img/rank_background2_official.bfc92f5d.png";